module.exports = __webpack_public_path__ + "img/tooth5.95610bd5.png";